import React, { useEffect } from "react";

const CommunicationPreferences = () => {
  useEffect(() => {
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.src = "//r1.dotdigital-pages.com/resources/sharing/embed.js";
    s.dataset.sharing = "lp-embed";
    s.dataset.pageDomain = "r1.dotdigital-pages.com";
    s.dataset.pageId = "4NXZ-CJT/communication-preferences";
    document.getElementById("communicationPreferencesContainer").appendChild(s);
  }, []);

  return <div id="communicationPreferencesContainer" />;
};

export default CommunicationPreferences;
